"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(_ref) {
  var name = _ref.name,
      fileList = _ref.fileList,
      postUrl = _ref.postUrl;

  var instance = {},
      events = {},
      formData = new FormData(),
      trigger = function trigger(event) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!events[event] || !events[event].queue.length) {
      return;
    } // Cycle through topics queue, fire!


    events[event].queue.forEach(function (item) {
      item.listener(data);
    });
  },
      upload = function upload() {
    // Use good ol' xhr request, because fetch doesn't supply progress.
    var xhr = new XMLHttpRequest();
    xhr.open('POST', postUrl);
    xhr.addEventListener('load', function (e) {
      var response = e.target;

      if (response.status === 200) {
        // Upload was successful
        trigger('success', response);
      } else {
        trigger('error', response.message);
      }
    });
    xhr.addEventListener('error', function () {
      trigger('error');
    });
    xhr.upload.addEventListener('progress', function (e) {
      if (e.lengthComputable) {
        trigger('progress', {
          loaded: e.loaded,
          total: e.total
        });
      }
    });
    xhr.send(formData);
    trigger('start');
  }; // Create FormData


  for (var i = fileList.length; i--;) {
    formData.append(name, fileList[i]);
  }

  instance.start = upload; // Observable

  instance.on = function (event, listener) {
    if (!events[event]) {
      events[event] = {
        queue: []
      };
    }

    events[event].queue.push({
      listener: listener
    });
  };

  instance.off = function () {
    delete events[event];
  };

  return instance;
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/upload-modal/uploader.js
// module id = 736
// module chunks = 0